import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        webConNews: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        webConNewMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getWebConNewsRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConNews", null);
            } else {
                dispatch("receivingWebConNews"); // สถานะ กำลังบันทึก


                // axios.get('/web_con_news').then(res => {
                //
                //     dispatch("receiveWebConNews", res.data);
                // })


                const formData = new FormData();
                formData.append('news_stratrgic_tag', payload.news_stratrgic_tag);
                formData.append('news_type_tag', payload.news_type_tag);

                axios.get('/web_con_news', {params: payload})
                    .then(function (res) {
                        dispatch("receiveWebConNews", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveWebConNews", null);
                    });

            }
        },
        loadWebConNewRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConNew", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWebConNew");
                axios.get('/web_con_news/' + id).then(res => {
                    dispatch("receiveWebConNew", res.data);
                })
            }
        },
        updateWebConNewRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWebConNew");
            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('file_en', payload.avatarFileEn);
            formData.append('news_id', payload.news_id);
            formData.append('news_stratrgic_tag', payload.news_stratrgic_tag);
            formData.append('news_type_tag', payload.news_type_tag);
            formData.append('news_h_image_th', payload.news_h_image_th);
            formData.append('news_h_image_en', payload.news_h_image_en);
            formData.append('news_title_th', payload.news_title_th);
            formData.append('news_title_en', payload.news_title_en);
            formData.append('news_content_th', payload.news_content_th);
            formData.append('news_content_en', payload.news_content_en);
            formData.append('news_tag', payload.news_tag);
            formData.append('news_sdgs', payload.news_sdgs);
            formData.append('new_start_date', payload.new_start_date);
            formData.append('order_seq', payload.order_seq);
            formData.append('switch_lang', payload.switch_lang);
            formData.append('news_a', payload.news_a);
            formData.append('news_b', payload.news_b);
            formData.append('news_c', payload.news_c);
            formData.append('news_d', payload.news_d);
            formData.append('news_e', payload.news_e);
            formData.append('news_f', payload.news_f);
            formData.append('news_g', payload.news_g);
            formData.append('news_h', payload.news_h);
            formData.append('switch_calendar', payload.switch_calendar);
            formData.append('active', payload.active);
            axios.post('/update_con_news', formData).then(res => {
                dispatch("updateWebConNew", res.data);
            })

        },
        createWebConNewRequest({dispatch}, payload) {

            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWebConNew");

            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('file_en', payload.avatarFileEn);
            formData.append('news_stratrgic_tag', payload.news_stratrgic_tag);
            formData.append('news_type_tag', payload.news_type_tag);
            formData.append('news_h_image_th', payload.news_h_image_th);
            formData.append('news_h_image_en', payload.news_h_image_en);
            formData.append('news_title_th', payload.news_title_th);
            formData.append('news_title_en', payload.news_title_en);
            formData.append('news_content_th', payload.news_content_th);
            formData.append('news_content_en', payload.news_content_en);
            formData.append('news_tag', payload.news_tag);
            formData.append('news_sdgs', payload.news_sdgs);
            formData.append('new_start_date', payload.new_start_date);
            formData.append('order_seq', payload.order_seq);
            formData.append('switch_lang', payload.switch_lang);
            formData.append('news_a', payload.news_a);
            formData.append('news_b', payload.news_b);
            formData.append('news_c', payload.news_c);
            formData.append('news_d', payload.news_d);
            formData.append('news_e', payload.news_e);
            formData.append('news_f', payload.news_f);
            formData.append('news_g', payload.news_g);
            formData.append('news_h', payload.news_h);
            formData.append('switch_calendar', payload.switch_calendar);
            formData.append('active', payload.active);


            axios.post('/web_con_news', formData).then(res => {
                dispatch("receiveWebConNew", res.data);

            })


        },
        deleteWebConNewRequest({dispatch}, payload) {

            dispatch("afterDeleteWebConNew", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWebConNew", payload);

            axios.post('/delete_con_news', payload).then(res => {
                dispatch("deleteWebConNew", {pages_id: payload.pages_id, res: res});
            })


        },
        receiveWebConNews({commit}, payload) {
            commit("RECEIVED_CONNEWS", payload)
        },
        receivingWebConNews({commit}) {
            commit("RECEIVING_CONNEWS") //call matutions --> state.isReceiving = true;
        },
        receiveWebConNew({commit}, payload) {
            commit("RECEIVED_CONNEW", payload)
        },
        receivingWebConNew({commit}) {
            commit("RECEIVING_CONNEWS") //call matutions --> state.isReceiving = true;
        },
        updateWebConNew({commit}, payload) {
            commit("UPDATED_CONNEW", payload)
        },
        updatingWebConNew({commit}) {
            commit("UPDATING_CONNEW") //  call matutions --> state.isUpdating = true;
        },
        deleteWebConNew({commit}, payload) {
            commit("DELETED_CONNEW", payload)
        },
        deletingWebConNew({commit}, payload) {
            commit("DELETING_CONNEW", payload)
        },
        afterDeleteWebConNew({commit}, payload) {
            commit("AFFTER_DELETED_CONNEW", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_CONNEWS(state, payload) {
            state.webConNews = payload;
            state.isReceiving = false;

        },
        RECEIVING_CONNEWS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_CONNEW(state, payload) {


            if (payload.news_id == undefined) {
                let error = payload.e.errorInfo == undefined ? payload.message : payload.e.errorInfo.toString()
                let webConNewMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    webConNewMessage: (state.webConNewMessage == webConNewMessage ? webConNewMessage + ' ' : webConNewMessage),

                });
            } else {
                let webConNewMessage = 'บันทึกสำเร็จ! รายการ ' + payload.news_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    webConNews: [...state.webConNews, payload],
                    isReceiving: false,
                    errorMessage: false,
                    webConNewMessage: (state.webConNewMessage == webConNewMessage ? webConNewMessage + ' ' : webConNewMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_CONNEW(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_CONNEW(state, payload) {
            let index = state.webConNews.findIndex(p => p.news_id === payload.news_id);
            let webConNewMessage = 'บันทึกสำเร็จ! รายการ ' + payload.news_id + ' ถูกแก้ไขแล้ว';

            state = Object.assign(state, {
                webConNews: state.webConNews.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                webConNewMessage: (state.webConNewMessage == webConNewMessage ? webConNewMessage + ' ' : webConNewMessage),
            })
        },
        UPDATING_CONNEW(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_CONNEW(state, payload) {
            console.log(payload)


            if (payload.res.data.news_id == undefined || payload.res.data.message == 'Relation') {
                let webConNewMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.news_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    webConNewMessage: (state.webConNewMessage == webConNewMessage ? webConNewMessage + ' ' : webConNewMessage),

                });
            } else {
                let indexToDelete = state.webConNews.findIndex(p => p.news_id === payload.res.data.news_id);
                let webConNews = [...state.webConNews];
                webConNews.splice(indexToDelete, 1);
                let webConNewMessage = 'บันทึกสำเร็จ! รายการ ' + payload.res.data.news_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    webConNews: [...webConNews],
                    isDeleting: false,
                    idToDelete: null,
                    webConNewMessage: (state.webConNewMessage == webConNewMessage ? webConNewMessage + ' ' : webConNewMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_CONNEW(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.news_id;
        },
        AFFTER_DELETED_CONNEW(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
